import React, { useState } from "react";
import Modal from "react-modal";
import { Button } from "@/components/ui/button";

interface ConfirmRegisterWaitlistModalProps {
  isOpen: boolean;
  onClose: () => void;
  userFullName: string;
  onConfirm: (sendNotification: boolean) => Promise<void>;
}

function ConfirmRegisterWaitlistModal({
  isOpen,
  onClose,
  userFullName,
  onConfirm,
}: ConfirmRegisterWaitlistModalProps) {
  const [isWorking, setIsWorking] = useState(false);
  const [sendNotification, setSendNotification] = useState(true);

  const handleConfirm = async () => {
    setIsWorking(true);
    try {
      await onConfirm(sendNotification);
      onClose();
    } catch (error) {
      console.error("Failed to register from waitlist:", error);
    } finally {
      setIsWorking(false);
    }
  };

  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        content: {
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          borderRadius: "8px",
          padding: "24px",
          background: "white",
          boxShadow: "0 10px 25px rgba(0,0,0,.3)",
          width: "calc(100% - 32px)",
          maxWidth: "500px",
          minBlockSize: "fit-content",
          overflowY: "auto",
        },
        overlay: {
          backgroundColor: "rgba(0,0,0,0.3)",
          zIndex: 9999,
        },
      }}
    >
      <h3 className="text-xl font-semibold text-gray-900">
        Register from Waitlist
      </h3>
      <p className="mt-3 text-sm text-gray-600">
        Are you sure you want to register <strong>{userFullName}</strong> from
        the waitlist?
      </p>

      <label className="mt-4 flex items-center gap-2 cursor-pointer">
        <input
          checked={sendNotification}
          className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          onChange={(e) => setSendNotification(e.target.checked)}
          type="checkbox"
        />
        <span className="text-sm text-gray-700">
          Send notification to the user
        </span>
      </label>

      <div className="mt-6 flex justify-end space-x-3">
        <Button disabled={isWorking} onClick={onClose} variant="outline">
          Cancel
        </Button>
        <Button disabled={isWorking} onClick={handleConfirm}>
          {isWorking ? "Registering..." : "Register"}
        </Button>
      </div>
    </Modal>
  );
}

export default ConfirmRegisterWaitlistModal;
